import { aawzDate } from '@utils/dates/aawz-date'

const toDate = (value) => {
  if (!value) return null
  if (value instanceof Date) return new Date(value)

  // Manter o fix: Strings YYYY-MM-DD em horário Local para evitar offset de 1 dia
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split('-').map(Number)
    return new Date(y, m - 1, d)
  }

  const date =
    typeof value === 'string' && value.includes('/')
      ? aawzDate(value, 'DD/MM/YYYY').toDate()
      : aawzDate(value).toDate()

  return Number.isNaN(date.getTime()) ? null : date
}

/**
 * Helper para formatar usando aawzDate (UTC) garantindo que o valor exibido
 * corresponda exatamente ao dia/mês/ano da instância Local.
 */
const lFormat = (value, mask) => {
  const d = toDate(value)
  if (!d) return 'Invalid date'
  // Normaliza o objeto local para uma data UTC com os mesmos números
  const normalized = new Date(
    Date.UTC(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      d.getHours(),
      d.getMinutes(),
      d.getSeconds()
    )
  )
  return aawzDate(normalized).format(mask)
}

const startOfWeek = (value) => {
  const d = toDate(value)
  if (!d) return null
  const day = d.getDay()
  const diff = d.getDate() - day
  return new Date(d.getFullYear(), d.getMonth(), diff)
}

export const formatISODate = (value) => {
  const d = toDate(value)
  if (!d) return ''
  const pad = (v) => String(v).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export const formatDateBR = (value) => {
  return lFormat(value, 'DD/MM/YYYY')
}

export const addDays = (value, amount) => {
  const d = toDate(value)
  return d
    ? aawzDate(d)
        .add(Number(amount || 0), 'days')
        .toDate()
    : null
}

export const addMonths = (value, amount) => {
  const d = toDate(value)
  return d
    ? aawzDate(d)
        .add(Number(amount || 0), 'months')
        .toDate()
    : null
}

export const addYears = (value, amount) => {
  const d = toDate(value)
  return d
    ? aawzDate(d)
        .add(Number(amount || 0), 'years')
        .toDate()
    : null
}

export const isSameDay = (a, b) => {
  const left = formatISODate(a)
  const right = formatISODate(b)
  return Boolean(left) && left === right
}

export const isToday = (value) => isSameDay(value, new Date())

export const getWeekDays = (value) => {
  const start = startOfWeek(value)
  if (!start) return []
  return [0, 1, 2, 3, 4, 5, 6].map((offset) => addDays(start, offset))
}

export const getMonthGrid = (value) => {
  const d = toDate(value)
  if (!d) return []
  const firstDay = aawzDate(d).startOf('month').toDate()
  const start = startOfWeek(firstDay)
  return Array.from({ length: 42 }, (_, i) => addDays(start, i))
}

export const formatHourLabel = (hour) => String(hour).padStart(2, '0') + ':00'

export const formatWeekdayShort = (value) => {
  const f = lFormat(value, 'DDD')
  return f === 'Invalid date' ? '' : f
}

export const formatMonthShort = (value) => {
  const f = lFormat(value, 'MMM')
  return f === 'Invalid date' ? '' : f.toLowerCase()
}

const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

export const formatMonthLong = (value) => {
  const d = toDate(value)
  if (!d) return ''
  const monthIndex = d.getMonth()
  const year = d.getFullYear()
  return `${MONTHS[monthIndex]} ${year}`
}

export const getMonth = (value) => {
  const d = toDate(value)
  return d ? d.getMonth() : Number.NaN
}

export const getYear = (value) => {
  const d = toDate(value)
  return d ? d.getFullYear() : Number.NaN
}

export const getDateNumber = (value) => {
  const d = toDate(value)
  return d ? d.getDate() : Number.NaN
}

export default {
  addMonths,
  addYears,
  addDays,
  formatHourLabel,
  formatISODate,
  formatDateBR,
  formatMonthLong,
  formatMonthShort,
  formatWeekdayShort,
  getDateNumber,
  getMonth,
  getYear,
  getMonthGrid,
  getWeekDays,
  isSameDay,
  isToday,
  toDate,
}
